/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardTitlePrimary,
  CardContent,
  Input,
  Radio,
  Tooltip
} from '@design-system-coopeuch/web';
import AutocompleteSelector from 'ui-coopeuch-autocomplete-selector';
import { agregarformatoPesos } from '../../../../utils/index';
import { toogleScroll } from '../../../../utils/window';
import { isMobile } from '../../../../utils/platform';
import { DatosLabolares } from './styles';
import iconMensajeInfo from '../../../assets/img/icon/TooltTip.svg';

const isDeviceMobile = isMobile();

const DatosLaboralesCard = ({
  rutEmpleadorCard,
  nombreEmpleadorCard,
  listaCargosCard,
  listacontratoCard,
  antiguedadLaboralCard,
  listaAnoCard,
  formularioEstadoFunction,
  activarDatosLaboalresCard,
  capturarValoresFormularioFuncion,
  dataFormulario,
  obtenerCargoDatosLaborales,
  tiposDeCargoIndependiente,
  obtenemosContratoDatosLabolares,
  obtenemosTiempoTrabajandoDatosLabolares,
}) => {
  const {
    mostrarFormulario,
    estadoCheckboxTrabajador,
    estadoCheckboxIndependiente,
    checkBoxValue,
    formularioTrabajadorDependiente,
    cargoSeleccionado,
    textoAsistidoCuantoGana,
    textoAsistidoRut,
    textoAsistidohaceCuentoTrabajas,
    contratoSeleccionado,
    antiguedadTrabajador,
  } = dataFormulario;

  const { cuantoGanaAlMes, rutDependiente } = formularioTrabajadorDependiente[0];

  const [listaContratos, setListaContratos] = useState([]);
  const [contrato, setContrato] = useState('');
  const [cargoMounted, setCargoMounted] = useState(false);
  const [contratoMounted, setContratoMounted] = useState(false);

  const handleVisibilityAutocomplete = (e) => {
    if (isDeviceMobile) toogleScroll('body', !e.isSuggestionListVisible);
  };

  useEffect(() => {
    capturarValoresFormularioFuncion(rutEmpleadorCard, 'rutEmpleador');
    capturarValoresFormularioFuncion(antiguedadLaboralCard, 'contratoActual');
  }, []);

  useEffect(() => {
    if (checkBoxValue === 'trabajador') {
      capturarValoresFormularioFuncion(antiguedadLaboralCard, 'contratoActual');
    } else {
      capturarValoresFormularioFuncion(10, 'contratoActual');
    }
  }, [checkBoxValue]);

  useEffect(() => {
    if (listacontratoCard.length && listaContratos.length === 0) {
      const nuevaListaContrato = listacontratoCard.map(function (item) {
        return { codigo: item.codigo.toString(), descripcion: item.descripcion };
      });
      setListaContratos(nuevaListaContrato);
    }
  }, [listacontratoCard]);

  useEffect(() => {
    if (!contratoMounted && contratoSeleccionado.codigo !== '') {
      obtenemosContratoDatosLabolares(contratoSeleccionado);
      setContratoMounted(true);
    }
    setContrato({
      codigo: contratoSeleccionado.codigo.toString(),
      descripcion: contratoSeleccionado.descripcion,
    });
  }, [contratoSeleccionado]);

  useEffect(() => {
    if (
      contratoSeleccionado.descripcion === 'PENSIONADO' &&
      listaContratos.length > 0 &&
      listaCargosCard.length > 0 &&
      !cargoMounted &&
      mostrarFormulario
    ) {
      obtenemosContratoDatosLabolares({ codigo: '5', descripcion: 'PENSIONADO' });
      setCargoMounted(true);
    }
  }, [contratoSeleccionado, listaContratos, listaCargosCard, mostrarFormulario]);

  useEffect(() => {
    if (checkBoxValue === 'dependiente') {
      setCargoMounted(false);
    }
  }, [checkBoxValue]);

  return (
    <DatosLabolares>
      <div className={!activarDatosLaboalresCard ? 'contenido off' : 'contenido on'}>
        <Card>
          <CardTitlePrimary title="Datos laborales" />
          <CardContent>
            <div className="contenido-card">
              <p className="datos-radio">¿Cuál es tu modalidad de trabajo?</p>
              <div className="label-radio">
                <Radio
                  checked={estadoCheckboxTrabajador}
                  disabled={false}
                  label="Soy trabajador dependiente"
                  name="soyTrabajadorDependiente"
                  onChange={() => formularioEstadoFunction('trabajador')}
                />
                <Radio
                  checked={estadoCheckboxIndependiente}
                  disabled={false}
                  label="Soy independiente"
                  name="SoyIndependiente"
                  onChange={() => formularioEstadoFunction('dependiente')}
                />
              </div>
              {mostrarFormulario && (
                <form
                  className={
                    checkBoxValue === 'dependiente'
                      ? 'formulario-datos-laborales editar-row'
                      : 'formulario-datos-laborales'
                  }
                >
                  <div className={checkBoxValue === 'dependiente' ? 'label none-label' : 'label'}>
                    {checkBoxValue === 'trabajador' && (
                      <Input
                        assistText={textoAsistidoRut}
                        label="RUT Empleador"
                        maxLength="12"
                        placeholder="Ej: 19.222.333-2"
                        variant="text"
                        value={rutDependiente === '' ? '' : rutDependiente}
                        onChange={(e) => capturarValoresFormularioFuncion(e, 'rutEmpleador')}
                      />
                    )}
                  </div>

                  <div className={checkBoxValue === 'dependiente' ? 'label none-label' : 'label'}>
                    {checkBoxValue === 'NA' && (
                      <Input
                        label="Empleador"
                        variant="text"
                        value={nombreEmpleadorCard !== undefined ? nombreEmpleadorCard : ''}
                      />
                    )}
                  </div>
                  <div
                    className={
                      checkBoxValue === 'dependiente'
                        ? 'label none-label tipo-cargo'
                        : 'label tipo-cargo'
                    }
                  >
                    {checkBoxValue === 'trabajador' && (
                      <AutocompleteSelector
                        idElement="contrato-selector"
                        label="¿Qué tipo de contrato tienes?"
                        value={contrato}
                        onChangeSuggestionVisibility={handleVisibilityAutocomplete}
                        placeholder="Selecciona"
                        name_attr_value="codigo"
                        name_text_node="descripcion"
                        items={listaContratos}
                        onSelection={(e) => obtenemosContratoDatosLabolares(e)}
                      />
                    )}
                  </div>
                  <div className={checkBoxValue === 'dependiente' ? 'label none-label' : 'label'}>
                    {checkBoxValue === 'trabajador' && (
                      <AutocompleteSelector
                        idElement="cargo-selector"
                        label="¿Cuál es tu cargo?"
                        value={cargoSeleccionado}
                        onChangeSuggestionVisibility={handleVisibilityAutocomplete}
                        placeholder="Selecciona"
                        name_attr_value="codigo"
                        name_text_node="descripcion"
                        items={listaCargosCard}
                        onSelection={(e) => obtenerCargoDatosLaborales(e)}
                      />
                    )}
                  </div>

                  <div
                    className={
                      checkBoxValue === 'trabajador'
                        ? 'label solo-responsive hace-cuento-trabajas-div'
                        : 'label'
                    }
                  >
                    <AutocompleteSelector
                      idElement="tiempo-trabajando-selector"
                      assistText={textoAsistidohaceCuentoTrabajas}
                      label={
                        checkBoxValue === 'trabajador'
                          ? '¿Hace cuánto trabajas aquí?'
                          : '¿Hace cuánto eres independiente?'
                      }
                      value={antiguedadTrabajador}
                      onChangeSuggestionVisibility={handleVisibilityAutocomplete}
                      placeholder="Selecciona"
                      name_attr_value="codigo"
                      name_text_node="descripcion"
                      items={
                        checkBoxValue === 'trabajador' ? listaAnoCard : tiposDeCargoIndependiente
                      }
                      onSelection={(e) => obtenemosTiempoTrabajandoDatosLabolares(e)}
                    />
                    <div className="_3MBFe ">
                      <div>
                        <span>Tiempo en tu actual trabajo</span>
                      </div>
                    </div>
                  </div>
                  <div className="label label-renta">
                    <div className="tooltip">
                      <p>
                        {checkBoxValue === 'trabajador'
                          ? '¿Cuál es tu última renta líquida recibida?'
                          : '¿Cuál es tu último ingreso líquido recibido?'}
                      </p>
                      <Tooltip
                        placement="top-end"
                        eventListener="hover"
                        interactive={false}
                        content="Nos referimos al monto final que recibes como pago luego de que se hayan descontado tus cotizaciones, previsiones y el seguro de cesantía."
                      >
                        <img src={iconMensajeInfo} alt="usuario TC" />
                      </Tooltip>
                    </div>
                    <Input
                      assistText={textoAsistidoCuantoGana}
                      value={
                        cuantoGanaAlMes === '' ? '' : `$${agregarformatoPesos(cuantoGanaAlMes)}`
                      }
                      placeholder="$ Ej: 422.300"
                      variant="text"
                      onChange={(e) => capturarValoresFormularioFuncion(e, 'cuantosGanas')}
                    />
                  </div>
                </form>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
    </DatosLabolares>
  );
};

DatosLaboralesCard.propTypes = {
  formularioEstadoFunction: PropTypes.func,
  rutEmpleadorCard: PropTypes.number,
  nombreEmpleadorCard: PropTypes.string,
  listaCargosCard: PropTypes.arrayOf(PropTypes.any),
  listacontratoCard: PropTypes.arrayOf(PropTypes.any),
  antiguedadLaboralCard: PropTypes.number,
  listaAnoCard: PropTypes.arrayOf(PropTypes.any),
  activarDatosLaboalresCard: PropTypes.bool,
  capturarValoresFormularioFuncion: PropTypes.func,
  dataFormulario: PropTypes.objectOf(PropTypes.any),
  obtenerCargoDatosLaborales: PropTypes.func,
  obtenemosContratoDatosLabolares: PropTypes.func,
  obtenemosTiempoTrabajandoDatosLabolares: PropTypes.func,
  tiposDeCargoIndependiente: PropTypes.arrayOf(PropTypes.object),
};

DatosLaboralesCard.defaultProps = {
  formularioEstadoFunction: () => {},
  rutEmpleadorCard: '',
  nombreEmpleadorCard: '',
  listaCargosCard: [],
  listacontratoCard: {},
  antiguedadLaboralCard: [],
  listaAnoCard: '',
  activarDatosLaboalresCard: false,
  capturarValoresFormularioFuncion: () => {},
  obtenemosContratoDatosLabolares: () => {},
  obtenemosTiempoTrabajandoDatosLabolares: () => {},
  dataFormulario: [{}],
  obtenerCargoDatosLaborales: () => {},
  tiposDeCargoIndependiente: [{}],
};

export default DatosLaboralesCard;
